// extracted by mini-css-extract-plugin
export default {"projectIcons":"V3YrAwiUquaYnbIdTZr6","navIconTooltip":"HLCdrVbWJyfHGmvFnCGi"};